import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n/I18nContext";
import { InstallPWA } from "@/components/InstallPWA";
import { Onboarding } from "@/components/Onboarding";
import History from "@/pages/History";
import Favorites from "@/pages/Favorites";
import Recommendations from "@/pages/Recommendations";
import Scan from "@/pages/Scan";
import Overview from "@/pages/Overview";
import Search from "@/pages/Search";
import ProductDetail from "@/pages/ProductDetail";
import Auth from "@/pages/Auth";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/AdminDashboard";
import DataPanel from "@/pages/DataPanel";

function App() {
  return (
    <div className="App">
      <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<History />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/recs" element={<Recommendations />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/search" element={<Search />} />
            <Route path="/product/:barcode" element={<ProductDetail />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/data" element={<DataPanel />} />
          </Routes>
          <InstallPWA />
        </BrowserRouter>
        <Onboarding />
        <Toaster position="top-center" richColors />
      </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
